import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";

export function usePolling(statusUrl, { onProgress, onFinish, interval = 1000 } = {}) {
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState(null);
  const pollRef = useRef(null);

  const stopPolling = useCallback(() => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
    setRunning(false);
  }, []);

  const startPolling = useCallback((startUrl, body = null) => {
    const poll = async () => {
      try {
        const res = await axios.get(statusUrl);
        const status = res.data;
        setProgress(status);
        if (onProgress) onProgress(status);
        if (status.finished) {
          stopPolling();
          if (onFinish) onFinish(status);
        }
      } catch (e) {
        stopPolling();
      }
    };

    const begin = async () => {
      if (startUrl) {
        if (body) await axios.post(startUrl, body);
        else await axios.post(startUrl);
      }
      setRunning(true);
      await new Promise(r => setTimeout(r, 500));
      poll();
      pollRef.current = setInterval(poll, interval);
    };

    begin();
  }, [statusUrl, onProgress, onFinish, interval, stopPolling]);

  // Auto-resume la mount
  useEffect(() => {
    if (!statusUrl) return;
    const checkResume = async () => {
      try {
        const res = await axios.get(statusUrl);
        const status = res.data;
        if (status.running) {
          setRunning(true);
          setProgress(status);
          if (onProgress) onProgress(status);
          pollRef.current = setInterval(async () => {
            try {
              const r = await axios.get(statusUrl);
              const s = r.data;
              setProgress(s);
              if (onProgress) onProgress(s);
              if (s.finished) {
                stopPolling();
                if (onFinish) onFinish(s);
              }
            } catch (e) {
              stopPolling();
            }
          }, interval);
        }
      } catch (e) {}
    };
    checkResume();
    return () => stopPolling();
  }, [statusUrl]);

  return { running, progress, startPolling, stopPolling };
}
